import * as React from "react";
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { RedirectContext, withContext } from "@focus/focusUI";
import { urlStringToObject, urlObjectToString } from "@focus/services";
import { useCurrentScenWks } from "@focus/services/lib/scenarios-focus/hooks";
export const _QueryParams = (rest) => {
    const { workspace, scenario } = useCurrentScenWks();
    return (React.createElement(Route, { render: (props) => {
            const params = urlStringToObject(props.location.search);
            const setParam = (id, value) => {
                const newQuery = Object.assign(Object.assign({}, params), { [id]: value });
                rest.redirect(Object.assign(Object.assign({}, props.location), { search: `?${urlObjectToString(newQuery)}`, workspace,
                    scenario }));
            };
            const setParams = (paramsList) => {
                const newQuery = Object.assign({}, paramsList);
                rest.redirect(Object.assign(Object.assign({}, props.location), { search: `?${urlObjectToString(newQuery)}`, workspace,
                    scenario }));
            };
            const getParam = (id, value) => {
                delete params.key;
                const newQuery = Object.assign(Object.assign({}, params), { [id]: value });
                return Object.assign(Object.assign({}, props.location), { search: `?${urlObjectToString(newQuery)}` });
            };
            return rest.children({ setParam, params, setParams, getParam });
        } }));
};
const mapDispatchToProps = (dispatch, { _redirect }) => {
    return {
        redirect: (payload) => dispatch(_redirect.actions.redirectTo(payload)),
    };
};
const Connected = withRouter(connect(null, mapDispatchToProps, null, { pure: false })(_QueryParams));
const contextConfig = {
    _redirect: RedirectContext,
};
export const QueryParams = withContext(contextConfig)(Connected);
//# sourceMappingURL=QueryParams.js.map